"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TRACKED_LIMIT = 599999;
//# sourceMappingURL=limits.js.map